import { useContext } from 'react';
import { LangContext } from '@/app/context/lang-context';

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
}
